import styled from 'styled-components';
import { Link } from 'react-router-dom';
// icons
import {
  Home24,
} from '@carbon/icons-react';

const SubHeader = ({
  title,
  subtitle,
  size = "md",
  style = {}
}) => {
  return (
    <Container style={style}>
      <Title size={size}><Link to={"/"}>Dashboard</Link> / <Link to={"/studies"}> Studies</Link> / {title}</Title>
      {subtitle ? <Subtitle size={size}>{subtitle}</Subtitle> : <></>}
    </Container>
  );
};

export default SubHeader;

const getTitleSize = (size) => {
  switch(size) {
    case "sm": return "18px";
    case "md": return "20px";
    case "lg": return "24px";
    default: return "20px";
  }
}

const getSubtitleSize = size => {
  switch(size) {
    case "sm": return "14px";
    case "md": return "14px";
    case "lg": return "14px";
    default: return "14px";
  }
}

const getMarginBottom = size => {
  if(size === "lg") return "18px";
  return "12px";
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  
`

const Title = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: ${props => getTitleSize(props.size)};
  color: #161616;
  margin-bottom: ${props => getMarginBottom(props.size)};;
`

const Subtitle = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  line-height: 18px;
  font-size: ${props => getSubtitleSize(props.size)};
  color: #161616;
  margin-bottom: 24px;
`